import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'mobx-react'
import RootStore from './store'
import BaseRoute from './routes'
import './index.css'
import './i18n/config'

const rootStore = new RootStore()
ReactDOM.render(
  <Provider {...rootStore}>
    <BaseRoute/>
  </Provider>,
  document.getElementById('root')
)
